import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userDetails: null,
};

export const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAdminDetails: (state, action) => {
      state.userDetails = action.payload;
    },
  },
});

export const { setAdminDetails } = UserSlice.actions;

export default UserSlice.reducer;
